"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoorSessions = void 0;
var Session_1 = require("../../rmf_door_msgs/msg/Session");
var DoorSessions = /** @class */ (function () {
    function DoorSessions(fields) {
        if (fields === void 0) { fields = {}; }
        this.door_name = fields.door_name || '';
        this.sessions = fields.sessions || [];
    }
    DoorSessions.validate = function (obj) {
        var e_1, _a;
        if (typeof obj['door_name'] !== 'string') {
            throw new Error('expected "door_name" to be "string"');
        }
        if (!Array.isArray(obj['sessions'])) {
            throw new Error('expected "sessions" to be an array');
        }
        try {
            for (var _b = __values(obj['sessions'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    Session_1.Session.validate(v);
                }
                catch (e) {
                    throw new Error("in index ".concat(i, " of \"sessions\":\n  ") + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    DoorSessions.FullTypeName = 'rmf_door_msgs/msg/DoorSessions';
    return DoorSessions;
}());
exports.DoorSessions = DoorSessions;
/*

string door_name
Session[] sessions

*/
